<template>
  <Typo>
    <p class="mb-0 fs-big">
      {{ $t('Pre hľadaný výraz sme nenašli žiadne výsledky') }}
    </p>
  </Typo>
</template>
